// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Events-module--fadeInAnimation--8d330";
export var layout = "Events-module--layout--22e2c";
export var section = "Events-module--section--fad1b";
export var title = "Events-module--title--aeda1";